<template>
  <div v-if="ready">

    <v-row v-if="auth_user">
      <v-col :cols="1" />
      <v-col :cols="10" :key="redraw">
        <div>
          <div borderStyle="rc-border-thin-off">
            <v-row>
              <!-- <v-col :width="1" style="padding-top: 12px">
                <span style="padding: 5px;">Menu</span>
              </v-col> -->
              <v-col v-if="isRoleMechanic" :width="10" style="padding-top: 3px">
                <span :class="getClasses('home')" v-on:click="withButtonPressed({ field: 'home' })">Home</span>
                <span v-if="vehicles" :class="getClasses('vehicles')"
                  v-on:click="withButtonPressed({ field: 'vehicles' })">Vehicles & Trailers</span>
                <span v-if="equipment" :class="getClasses('equipment')"
                  v-on:click="withButtonPressed({ field: 'equipment' })">Equipment</span>
                <span v-if="inspections || equipment" :class="getClasses('inspections')"
                  v-on:click="withButtonPressed({ field: 'inspections' })">Inspections</span>
                <span v-if="checklists || equipment" :class="getClasses('checklists')"
                  v-on:click="withButtonPressed({ field: 'checklists' })">Checklists</span>
                <span v-if="inspections" :class="getClasses('reports')"
                  v-on:click="withButtonPressed({ field: 'reports' })">Reports</span>
              </v-col>
              <v-col v-else :width="10" style="padding-top: 3px">
                <span :class="getClasses('home')" v-on:click="withButtonPressed({ field: 'home' })">Home</span>
                <span :class="getClasses('whatsnew')" v-on:click="withButtonPressed({ field: 'whatsnew' })">Whats New?</span>
                <span v-if="compliance" :class="getClasses('compliance')"
                  v-on:click="withButtonPressed({ field: 'compliance' })">Compliance</span>
                <span v-if="vehicles" :class="getClasses('vehicles')"
                  v-on:click="withButtonPressed({ field: 'vehicles' })">Vehicles & Trailers</span>
                <span v-if="equipment" :class="getClasses('equipment')"
                  v-on:click="withButtonPressed({ field: 'equipment' })">Equipment</span>
                <span v-if="inspections || equipment" :class="getClasses('inspections')"
                  v-on:click="withButtonPressed({ field: 'inspections' })">Inspections</span>
                <span v-if="timesheets" :class="getClasses('hours')"
                  v-on:click="withButtonPressed({ field: 'hours' })">Hours of Service</span>
                <span :class="getClasses('users')" v-on:click="withButtonPressed({ field: 'users' })">Users</span>
                <span v-if="map" :class="getClasses('map')"
                  v-on:click="withButtonPressed({ field: 'map' })">Map</span>
                <span v-if="checklists || equipment" :class="getClasses('checklists')"
                  v-on:click="withButtonPressed({ field: 'checklists' })">Checklists</span>
                <span v-if="inspections" :class="getClasses('reports')"
                  v-on:click="withButtonPressed({ field: 'reports' })">Reports</span>
                <span :class="getClasses('invoices')"
                  v-on:click="withButtonPressed({ field: 'invoices' })">Invoices</span>
                <span :class="getClasses('billing/display')"
                  v-on:click="withButtonPressed({ field: 'billing/display' })">Billing</span>
                <span :class="getClasses('company/display')"
                  v-on:click="withButtonPressed({ field: 'company/display' })">Company</span>
                <span v-if="gpsDevice" :class="getClasses('gps/devices')"
                  v-on:click="withButtonPressed({ field: 'gps/devices', v3: true })">GPS Devices</span>
                <span v-if="isAdmin" :class="getClasses('admin')"
                  v-on:click="withButtonPressed({ field: 'admin' })">Admin</span>
                <span v-if="isV3" :class="getClasses('dashboard')"
                  v-on:click="withButtonPressed({ field: 'dashboard' })">Dashboard</span>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
      <v-col :cols="1" />
    </v-row>
    <v-row v-else>
    </v-row>
  </div>
</template>

<script>
import ContentUtils from '@/utils/ContentUtils.js';
import StringUtils from '@/utils/StringUtils.js';
import { mapGetters } from 'vuex';
import BooleanUtils from '../../utils/BooleanUtils';

export default {
  name: 'app-menu',
  components: {
  },
  data() {
    return {
      redraw: 1,
      ready: false,
    };
  },
  props: {
    isSmall: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters([
      'auth_user',
      'auth_client',
      'auth_connected',
      'domain',
      'CompanyStorage_lastEvent',
    ]),
    isRoleMechanic: function () {
      if (!this.domain || !this.domain.session()) {
        return false;
      }
      var employee = this.domain.session().employee();
      return employee.roles().find().isMechanic();
    },
    companyName: function () {
      if (!this.domain || !this.domain.session()) {
        return "";
      }
      var name = this.domain.session().company().name();
      return ContentUtils.unescape(name);
    },
    companyId: function () {
      if (!this.domain || !this.domain.session()) {
        return "";
      }
      var name = this.domain.session().company().id();
      return ContentUtils.baseEncode(name);
    },
    inspections: function () {
      if (!this.domain || !this.domain.session()) {
        return false;
      }
      var result = true;
      result = this.domain.session().company().features().find().allowsInspections();
      return result;
    },
    gpsDevice: function () {
      if (!this.domain || !this.domain.session()) {
        return false;
      }
      var result = true;
      result = this.domain.session().company().features().find().hasGpsDevice();
      return result;
    },
    timesheets: function () {
      if (!this.domain || !this.domain.session()) {
        return false;
      }
      var result = true;
      result = this.domain.session().company().features().find().allowsTimesheets();
      return result;
    },
    checkins: function () {
      if (!this.domain || !this.domain.session()) {
        return false;
      }
      var result = true;
      result = this.domain.session().company().features().find().allowsCheckIns();
      return result;
    },
    checklists: function () {
      if (!this.domain || !this.domain.session()) {
        return false;
      }
      var result = true;
      result = this.domain.session().company().features().find().allowsVehicles();
      return result;
    },
    vehicles: function () {
      if (!this.domain || !this.domain.session()) {
        return false;
      }
      var result = true;
      if (this.inspections) {
        return true;
      }
      result = this.domain.session().company().features().find().allowsVehicles();
      return result;
    },
    equipment: function () {
      if (!this.domain || !this.domain.session()) {
        return false;
      }
      var result = true;
      result = this.domain.session().company().features().find().allowsEquipment();
      return result;
    },
    schedules: function () {
      return true;
    },
    debug() {
      return this.auth_client.debug;
    },
    map() {
      if (!this.domain || !this.domain.session()) {
        return false;
      }
      return this.domain && this.domain.session().company().features().find().allowsMap();
    },
    compliance: function () {
      if (!this.domain || !this.domain.session()) {
        return false;
      }
      var result = true;
      var features = this.domain.session().company().features().find();
      result = features.allowsInspections() || features.allowsTimesheets();
      return result;
    },
    hasCompanys: function () {
      if (!this.domain || !this.domain.session()) {
        return false;
      }
      var user = this.domain.session().user();
      var employees = this.domain.employees().findByUserId(user.id());
      return employees.length() > 1;
    },
    isAdmin() {
      if (!this.domain || !this.domain.session()) {
        return false;
      }
      var user = this.domain.session().user();
      var employees = this.domain.employees().findByUserId(user.id());
      var roles = employees.roles().find();
      return roles.isAdministrator();
    },
    isV3() {
      if (!this.domain || !this.domain.session()) {
        return false;
      }
      var _isV3 =  BooleanUtils.toBoolean(window.localStorage["v3"] ?? true);
      return _isV3;
    }
  },
  watch: {
    $route(to, from) {
      if (to && from) {
        //
      }
      this.redraw++;
    },
    CompanyStorage_lastEvent() {
      this.redraw++;
    }
  },
  mounted() {
    this.ready = true;
  },
  methods: {
    getClasses(path) {
      let routePath = this.$route.path;
      let selected = false;
      if (routePath) {
        selected = StringUtils.cic(routePath, path);
      }
      if (selected) {
        return "rc-main-menu rc-input-button-clear-v2-selected rc-input-width-menu"
      }
      return "rc-main-menu clickable rc-input-button-clear-v2 rc-input-width-menu";
    },
    decode: function (value) {
      return ContentUtils.unescape(value);
    },
    first: function () {
      if (!this.domain || !this.domain.session()) {
        return "";
      }
      var name = this.domain.session().user().firstDisplay();
      return name;
    },
    withButtonPressed(buttonData) {
      if (!buttonData) {
        return;
      }
      window.console.log(JSON.stringify(buttonData, null, 2));
      let path = buttonData["field"];
      let id = this.domain.session().company().idEncoded();
      let prefix = "/portal/operator/";
      if (buttonData["v3"]) {
        prefix = "/portal/v3/operator/";
      }
      let newPath = prefix + id + "/" + path;
      this.$router.push({ path: newPath })
    },
    displayType() {
      return "clearAction";
    },
    email: function () {
      if (!this.domain || !this.domain.session()) {
        return "";
      }
      return this.domain.session().user().emailDisplay();
    },
  },
}
</script>